module.exports = ":host form input[type=text], :host form textarea {\n  width: 100%;\n  box-sizing: border-box; }\n"